import { get, post } from 'helpers/api_helper';

// Self-custody wallet confirmation (EIP-191 personal_sign). The address is set/changed
// ONLY by proving control of the private key — no manual entry.
const BASE = '/wallet/confirmation';

export const getWalletConfirmationStatus = () => get(`${BASE}/status`);

export const fetchWalletChallenge = async (address) => {
  const response = await post(`${BASE}/challenge`, { address });
  return response.data;
};

export const confirmWallet = async (address, signature) => {
  const response = await post(`${BASE}`, { address, signature });
  return response.data;
};

export const confirmWalletChange = async (emailCode) => {
  const response = await post(`${BASE}/confirm-change`, { email_code: emailCode });
  return response.data;
};
